import type { IModuleDefinition, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Дочірня таблиця пакета, яка в прототипі v4 — окремий модуль із батьком (mpfexp < mpf, amendment < bill, cnt < crm): реалізований видимий
 * неосновний тип записів модуля з ключем `key`; інакше (основний, спроєктований, прихований, невідомий тип) — undefined. На таблиці й
 * сторінках її налаштувань меню й сторінки «Налаштування» працюють у контексті цієї таблиці, як модуль прототипу. Чиста функція.
 */
export function childModuleType(module: IModuleDefinition, key: string | null | undefined): IRecordTypeDefinition | undefined {
  return key ? module.recordTypes.find((r) => r.key === key && !r.main && !r.hidden && r.status !== 'designed') : undefined;
}
